//shopify-domain-redirect-check
if(window.location.hostname !== "www.thepulseboutique.com" &&  window.location.hostname !== "the-pulse-boutique.myshopify.com" && window.location.href.indexOf("shopifypreview") === -1  ){
  window.location = "https://www.thepulseboutique.com/";
}

$(".cart__qty-field").on("change paste keyup", function() {
  var a = $(this).val();
 $(this).attr('value',a); 
});



/*  Mobile Nav */
$('.nav-trigger').click( function() {
    $("body").toggleClass("nav-active");
});

$( document ).ready(function() {
  
  
   var body = $('body').attr("class");  
if(body.indexOf('template-cart')!=-1){
     $(".quanBtn").click(function(e){   
       var getId =  $(this).attr("data-val");
       var cartQuan = $(".cartquan-"+getId).val();
      //console.log($(this).attr("value"));
      if($(this).attr("value")=="-")
      {
       var valget = parseInt(cartQuan)-1;

          if(valget < 1)
          { 
              //valget=1;
            $(".cartid-"+getId).remove();
          }

      }
      else{
         var valget = parseInt(cartQuan)+1 ;
       
      }
         $(".cartquan-"+getId).attr("value",valget);
       	 jQuery.post('/cart/update.js', "updates["+getId+"]="+valget); 
       
       //jQuery.post('/cart/update.js', {quantity: 10, id: 6907821326391});
      
       
       setTimeout(function(){
       window.location.href = '/cart';
      }, 1000);   
      /*
      var updatesObject = {
            updates: {
                quantity: valget,
                id: getId
                }
        }

      $.ajax({
        url: '/cart/update.js',
		dataType: "json",
        data: updatesObject,
        success: function(result) { //we got the response
          console.log('success');
         // document.cookie = 'cartupdated=' + "TRUE" + ';path=/'; 
          //window.location.reload();
        },
        error: function(jqxhr, status, exception) {
          if(jqxhr.status == 200) {
            console.log('error');
            //document.cookie = 'cartupdated=' + "TRUE" + ';path=/'; 
            //window.location.reload();
          }              
        }
      });
      */
          
       
    });    
  }


 
  /*  Hero Slider */
  $(".hero-slide").slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow: null,
    nextArrow: null,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  /*  Product Carousel */
  $(".product-carousel").slick({
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  
  /*  Review Carousel */
  $(".review-carousel").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  $(".center").slick({
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 5,
    slidesToScroll: 3
  });
  
  /*  Filter Select box Customization */
  $('.filter__select').select2({
    dropdownPosition: 'below',
    minimumResultsForSearch: -1
  });
  
  /*  Filter Collapse and Expand */
  $('.filter__toggle').click(function(){
  	$('.filter__bar').toggleClass('filter__bar-open');
  });

});

/*** Mobile nav inner click 
- This code is use for open the inner submenus
**** scripted by vasanth ******/
$(function(){
  var width = $(window).width();
  if(width <= 1023){
    
    /*  Mobile Sub Nav */
    $('.nav__sub > .box_style').click(function(e) {
      e.preventDefault();
      var sub_active = $(this).closest('.nav__sub').attr("class");

      if (sub_active.indexOf("is-active")!=-1) {
      } else {
        e.preventDefault();
        $('.nav__content').removeClass("is-active");
        $('.nav__content li').removeClass("is-active");
        $('.m__nav-submenu').removeClass("is-active--grand-child");

        if ($(this).closest('.nav__content').parent().hasClass('m__nav-submenu')) {
          $(this).closest('.nav__content').parent().addClass("is-active--grand-child");
        }
        $(this).parent().addClass("is-active");
        $(this).closest('.nav__content').addClass("is-active");
      }

    });
    $(".back__link").click(function(e){

      $('.m__nav-submenu').removeClass("is-active--grand-child");

      $(this).closest('.nav__sub').removeClass('is-active');
      $(this).closest('.nav__content').removeClass('is-active');

      $(this).closest('.nav__sub').parent().closest('.nav__sub').addClass('is-active');
      $(this).closest('.nav__content').parent().closest('.nav__content').addClass('is-active');

      e.preventDefault();
    });
  }
});

/*** Mobile header USB bar append functionality
- This code is use for header USB bar append functionality
**** scripted by vasanth ******/
 
$(function(){
  var width = $(window).width();
  var body = $("body").attr("data-template");
  if(body.indexOf("index")!=-1){
    if(width <= 1023){      
      $('.header__uspbar').clone().appendTo('.index__section').eq(0).removeClass('hidden-xs').removeClass("hidden-sm").addClass('hidden-ls').addClass('hidden-lm').addClass('mobile-usp');
      $(".mobile-usp .usp__bar").slick({
        dots: false,
        infinite: false,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              slidesToShow: 1
            }
          }
        ]
      });
      
    }
  }
  
   $(window).resize(function(){
      var width = $(window).width();
      var body = $("body").attr("data-template");
      if(body.indexOf("index")!=-1){
        if(width <= 1023){
          $(".mobile-usp").show();
        }else{
          $(".mobile-usp").hide();
        }
      }
   });
});

// ===== Scroll to Top ==== 
$(window).scroll(function() {
    if ($(this).scrollTop() >= 200) {      // If page is scrolled more than 50px
        $('.back-to-top').addClass('top-active'); 
    } else {
        $('.back-to-top').removeClass('top-active');
    }
});
$('.back-to-top').click(function() {       // When arrow is clicked
    $('body,html').animate({
        scrollTop : 0                      // Scroll to top of body
    }, 500);
});




/** Faq accordion ***/
$(function() {
		var Accordion = function(el, multiple) {
				this.el = el || {};
				this.multiple = multiple || false;

				var links = this.el.find('h6');
				links.on('click', {
						el: this.el,
						multiple: this.multiple
				}, this.dropdown)
		}

		Accordion.prototype.dropdown = function(e) {
				var $el = e.data.el;
				$this = $(this),
						$next = $this.next();
				$el.find('.accordion-content').removeClass("active");
          		$el.find('h6').removeClass("is-open");
				$next.slideToggle();
          		$next.addClass("active");
          		$this.addClass("is-open");
				$this.parent().toggleClass('open');

				if (!e.data.multiple) {                  		
						$el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
                };
		}
		var accordion = new Accordion($('.Faq_questions'), false);
});

/* VIP collection js */
$(function() {
  $('.vip-open-popup-link').magnificPopup({
        type:'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  $('.vip-open-popup-link').trigger("click");
});

/* Forgot password script */
$(function(){
  var $agree,
      $sts,
      $email,
      $error_txt;
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  $(".forgot_vip_pass").click(function(){
      $(".vip_login").hide();
      $("#vip_forget_password").show();
  });
  $(".forgot_cancel").click(function(){
      $("#vip_forget_password").hide();
      $(".vip_login").show();
      tab_load();
  });
  
  $("#create_customer_form").submit(function(){
    	$agree = $("#agree").prop('checked');
        $sts = 0;
        $email = $("#email").val();
        $error_txt = "";
        $(".form_list").find("error_register").remove();
        $(".vip_register").find(".errors").html("");
        $error_txt +='<div class="errors"><ul>';
        if(!regex.test($email)) {
          $sts = 1;
          $error_txt += "<li>Please enter valid email address</li>";
        }
        if($agree == false){
          $sts = 1;
          $error_txt += "<li>Please select the privacy policy</li>"
        }
        $error_txt +='</ul></div>';
        if($sts == 1){
          $( $error_txt ).insertAfter( ".vip_register h2" );
          return false;
        }
      	 
  });
  
});
  
/* VIP Tabbing */
$(window).on('load resize orientationchange', function () {
  tab_load();
});

function tab_load(){
    var win_width = $(window).width();
    var act = $(".tab_header_vip .active").attr("data-id");
    if(win_width<=768){   
      console.log(window.orientation);
      if(window.orientation == 0 || window.orientation == undefined){        
        
        if(act == "vip_login"){
          $(".login_act").addClass("active");          
          $(".vip_register").hide();
          $(".vip_login").show();
        }else if(act == "vip_register"){
          $(".register_act").addClass("active");
          $(".vip_login").hide();
          $(".vip_register").show();
        }

        $(".tab_header_vip a").on("click", function(){
          $(".tab_heading").removeClass("active");
          var tab_act = $(this).attr("data-id");
          $(this).addClass("active");
          if(tab_act == "vip_login"){
              $(".vip_register").hide();
              $(".vip_login").show();
          }
          if(tab_act == "vip_register"){
              $(".vip_login").hide();
              $(".vip_register").show();
          }
        });
      }else if(window.orientation == 90){
        $(".vip_login").show();
        $(".vip_register").show();        
      }
      
    }else{
      $(".vip_login").show();
      $(".vip_register").show();      
    }
}


/* currency script */
currency_load();
function currency_load(){
  var currency_format,
      shop_currency,
      defaultCurrency,
      money_with_currency_format,
      money_format;
  currency_format = $("#currency_format").val();
  shop_currency = $("#shop_currency").val();
  defaultCurrency = $("#defaultCurrency").val();
  money_with_currency_format = $("#money_with_currency_format").text();
  money_format = $("#money_format").text();
  
  Currency.format = currency_format;

  var shopCurrency = shop_currency;

  /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
  Currency.moneyFormats[shopCurrency].money_with_currency_format = money_with_currency_format;
  Currency.moneyFormats[shopCurrency].money_format = money_format;

  /* Default currency */
  var defaultCurrency = defaultCurrency;

  /* Cookie currency */
  var cookieCurrency = Currency.cookie.read();

  /* Fix for customer account pages */
  $('span.money span.money').each(function() {
    $(this).parents('span.money').removeClass('money');
  });

  /* Saving the current price */
  $('span.money').each(function() {
    $(this).attr('data-currency-', jQuery(this).html());
  });

  // If there's no cookie.
  if (cookieCurrency == null) {
    if (shopCurrency !== defaultCurrency) {
      Currency.convertAll(shopCurrency, defaultCurrency);
    }
    else {
      Currency.currentCurrency = defaultCurrency;
    }
  }
  // If the cookie value does not correspond to any value in the currency dropdown.
  else if ($('.mh__actions [name=currencies]').length && $('.mh__actions [name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
    Currency.currentCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
  }
  else if (cookieCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  }
  else {
    Currency.convertAll(shopCurrency, cookieCurrency);
  }

  $('.mh__actions [name=currencies]').val(Currency.currentCurrency).change(function() {
    var newCurrency = $(this).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    $('.selected-currency').text(Currency.currentCurrency);
  });

  var original_selectCallback = window.selectCallback;
  var selectCallback = function(variant, selector) {
    original_selectCallback(variant, selector);
    Currency.convertAll(shopCurrency, jQuery('.mh__actions [name=currencies]').val());
    $('.selected-currency').text(Currency.currentCurrency);
  };

  $('body').on('ajaxCart.afterCartLoad', function(cart) {
    Currency.convertAll(shopCurrency, $('.mh__actions [name=currencies]').val());
    $('.selected-currency').text(Currency.currentCurrency);
  });

  $('.selected-currency').text(Currency.currentCurrency);
}

/* Change mobile currency selector (primary) on changing the desktop currency (secondary) selector */

const currencySelectorDesktop = document.querySelector('.mobile-hide-announcement-bar .currency-picker');
const currencySelectorMobile = document.querySelector('.mh__actions .currency-picker');

document.addEventListener('DOMContentLoaded', function() {
  initDesktopCurrencyValue(currencySelectorDesktop, currencySelectorMobile);
});

currencySelectorDesktop.addEventListener('change', function(evt) {
  let curreuncyValue = evt.target.value;
  currencySelectorMobile.value = curreuncyValue;

  let changeEvent = new Event("change");
  currencySelectorMobile.dispatchEvent(changeEvent);
});

function initDesktopCurrencyValue(fromSelector, toSelector) {
  fromSelector.value = toSelector.value;
  currencyImgUrls = fromSelector.dataset;

  handleSwitchCurrencyIcon(currencyImgUrls, fromSelector, toSelector);

  fromSelector.addEventListener('change', function() {
    handleSwitchCurrencyIcon(currencyImgUrls, fromSelector, toSelector);
  });
}

function handleSwitchCurrencyIcon(currenciesImagesObject, fromSelector, toSelector) {
  for (const [key, value] of Object.entries(currenciesImagesObject)) {
    if (key.toLowerCase() === `currencyflag${toSelector.value.toLowerCase()}`) {
      fromSelector.style.backgroundImage = `url(${value})`;
      break;
    }
  }
}
